import { useTheme } from '@emotion/react';
import { useState } from 'react';
import { tokens } from '../../../global/theme/tokens';
import { Box } from '@mui/material';
import ExoColorPicker from '../../special/ExoColorPicker';
import LabeledBox from '../../special/LabeledBox';

const TypeColor = ({
  field,
  updateValidationOnChange,
  dataCollection,
  objectKey,
  errors,
  size,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [open, setOpen] = useState(false);

  const handleColorSelect = (color) => {
    updateValidationOnChange(field.key, color);
  };

  return (
    <>
      <Box className="flex gap-2 " onClick={() => setOpen(true)}>
        <Box
          sx={{
            width: size === 'small' ? '40px' : '53px',
            minWidth: size === 'small' ? '40px' : '53px',
            height: size === 'small' ? '40px' : '53px',
            backgroundColor: objectKey
              ? dataCollection[objectKey][field.key]
              : dataCollection[field.key] || colors.bgInput,
            borderRadius: '10px',
            borderWidth: '0px',
            borderColor: colors.primary[300],
            ':hover': {
              borderColor: colors.primary[900],
              cursor: 'pointer',
            },
          }}
        ></Box>
        <LabeledBox
          className="w-full"
          size={size}
          label={field.label}
        ></LabeledBox>
      </Box>
      <ExoColorPicker
        open={open}
        onSelect={handleColorSelect}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default TypeColor;
